import { deleteMessages } from '../actions';
import { storage } from '../services/storage';
import { api, rtm } from '../services/http';
import startChat, { sendMessage } from '../services/chat';

let toSend = {};

export function messageListener (store) {
    window.addEventListener('message', event => {
        const payload = event.data;

        if (!payload) {
            return;
        }

        if (payload === "reset") {
            storage.destroy("history2");
            storage.destroy("history");
            storage.destroy("chatter");
            store.dispatch(deleteMessages());
            if (store.getState().chatter.get('id')) {
                startChat(store);
            }
        } else if (payload.constructor === Object) {
            if (payload.styles) {
                const styleSheet = document.createElement('style');
                styleSheet.type = 'text/css';

                styleSheet.appendChild(document.createTextNode(payload.styles))

                // Append the stylesheet to the head of the document
                document.head.appendChild(styleSheet);
            } else {
                let metaData = storage.retrieve('meta'),
                    chatter = storage.retrieve("chatter") || store.getState().chatter.get('id');

                if (!metaData) {
                    metaData = {};
                }

                for (var key in payload) {
                    Object.assign(metaData, payload);
                    Object.assign(toSend, payload);
                }
            
                storage.store('meta', metaData);

                // Implement setTimeout to handle short bursts of postMessages
                setTimeout(() => {
                    sendMetaData(store);
                }, 10)
            }
        }
    });
}

export function sendMetaData (store) {
    const chatter = storage.retrieve("chatter") || store.getState().chatter.get('id');

    if (chatter && store.getState().chatter.get('hasSentFirstMessage') && Object.keys(toSend).length) {
        api.patch(`/conversations/${chatter}/storage/`, toSend);
        toSend = {};
    }
}

export function setDocumentTitle (client) {
    if (client.name) {
        document.title = `${client.isFrench ? "Parlez avec" : "Chat with"} ${client.name}`;
    } else {
        document.title = `${client.isFrench ? "Parlez" : "Chat"}`;
    }
}


// WEBPACK FOOTER //
// ./src/services/global.js